import React, { useEffect, useState, useRef } from 'react'
import { Button } from '../../common/Button'
import { FormikObj } from './constant'
import { useFormik } from 'formik'
import SelectFiled from '../../common/textfield/SelectFiled'
import { failed } from "../../common/Toastify";
import { Col, Row } from 'react-bootstrap'
import TextInput from '../../common/textfield/TextInput'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { selectedRequestType, internalReferralTypeOptions } from '../Patient/Constants'
import { ArrowBack } from '@mui/icons-material'
import { usePatientEncounterHistoryQuery } from '../../../hooks/ReactQueryHooks/usePatientEncounterHistoryQuery'
import moment from 'moment'
import { useSelector } from 'react-redux'
import { useGetPdfDocumentsQuery } from '../../../hooks/ReactQueryHooks/useGetPdfDocumentsQuery'
import PdfViewerComponent, { validatePdfBeforeNext } from '../../common/components/PdfViewerComponent'
import { getPatientData, getSingleUser } from '../../api/Individual'
import { splitContactNumber } from '../../../utils/phoneNumberSupport'
import ServiceLocationModal from './ServiceLocationModal'
import { safeAgeString } from '../../../utils/DateSupport'
import { capitalizeWords } from '../../../utils/capitalizeWords'
import { getPractitionerSignatureSource } from '../../../utils/signatureSupport'
import InternalReferralWizard from './InternalReferralWizard'
import { getDiscover, getOrganization } from '../../api/Organization'
import BookingModal from '../../Admin/Scheduling/booking/BookingModal'
import { createInternalReferral } from '../api/ServiceRequest'
import { buildInternalReferralPayload, mapToReferralType } from './internalReferralPayload'
import { getEncounterRecord } from '../api/Encounter'
import { confirmAppointment } from '../../api/Scheduling/appointments'

const INTERNAL_REFERRAL_PERMISSION = "Create Service Referrals"

const isInternalReferralRequestType = (reqType) => reqType === 'InternalReferral'

const ServiceRequest = () => {
    const [openModal, setOpenModal] = useState(false)
    const [wizardOpen, setWizardOpen] = useState(false)
    const [patientData, setPatientData] = useState(true)
    const [encounteredData, setEncounteredData] = useState([])
    const [searchParams] = useSearchParams();
    const [documentOptions, setDocumentOptions] = useState([]);
    const [allDocuments, setAllDocuments] = useState([]);
    const [currentRequestType, setCurrentRequestType] = useState(null);
    const [pdfFormValuesReady, setPdfFormValuesReady] = useState(false);
    const [nextLoading, setNextLoading] = useState(false);
    const instanceRef = useRef(null);
    const initialPdfFormValues = useRef(null);
    const practitionerId = useSelector((state) => state?.auth?.user?.["custom:unique_id"]);
    const paramsObj = Object.fromEntries(searchParams?.entries())
    const requestTypeId = localStorage.getItem("requestTypeId")
    const storedRequestTypeValue = localStorage.getItem("requestTypeValue")
    const isFromInteractionUI = paramsObj?.fromPatient !== "true"
    const rawRequestType = paramsObj?.requestType
        ? paramsObj.requestType
        : isFromInteractionUI
            ? ""
            : storedRequestTypeValue ||
              selectedRequestType.find((obj) => obj?.id == requestTypeId)?.value ||
              "Lab"
    const requestType = rawRequestType === "InternalReferral" && !isFromInteractionUI ? "Lab" : rawRequestType
    const navigate = useNavigate()
    const user = useSelector((state) => state?.auth?.user);
    const adminOrgs = useSelector((state) => state?.auth?.user?.organizations)
    const permissions = useSelector((state) => state?.auth?.user?.permissions) || []
    const canCreateInternalReferral = permissions.includes(INTERNAL_REFERRAL_PERMISSION)
    const [encounterOrgId, setEncounterOrgId] = useState(null)
    const [wrEnabled, setWrEnabled] = useState(false)
    const [vvEnabled, setVvEnabled] = useState(false)
    const [bookingModalShow, setBookingModalShow] = useState(false)
    const [orgLicenseLoading, setOrgLicenseLoading] = useState(false)

    // Interaction UI: ZoomCreate/PhoneCallCreate pass fromPatient=false; patient chart passes fromPatient=true.
    // ZoomCreateVV passes encounterId without fromPatient — treat as interaction when not explicitly from patient chart.
    const activeRequestType = currentRequestType || requestType
    const isInternalReferral = isInternalReferralRequestType(activeRequestType)

    const requestTypeOptions = selectedRequestType
        .filter((item) => {
            if (item.value !== "InternalReferral") return true
            return (
                isFromInteractionUI &&
                canCreateInternalReferral &&
                (wrEnabled || vvEnabled)
            )
        })
        .map((item) => ({ ...item, name: item.name, value: item.value }))

    const availableReferralTypeOptions = internalReferralTypeOptions.filter(
        (option) =>
            (option.value === "WAITING_ROOM" && wrEnabled) ||
            (option.value === "SCHEDULE" && vvEnabled)
    )

    const filterDocumentsByRequestType = (data, reqType) => {
        return reqType == 'Lab' ?
            data.filter(item => item?.category?.[0]?.coding?.[0]?.code === "Lab Requisition").map(item => ({ ...item, name: item?.documentName, value: item?.id }))
                : ( reqType == 'Diagnostic' ? 
                data.filter(item => item?.category?.[0]?.coding?.[0]?.code === "Diagnostic Requisition").map(item => ({ ...item, name: item?.documentName, value: item?.id }))
                : data.filter(item => item?.category?.[0]?.coding?.[0]?.code === "Referral").map(item => ({ ...item, name: item?.documentName, value: item?.id })))
    };

    const onSuccessOfDocumentsList = (data) => {
        setAllDocuments(data);
        const activeType = currentRequestType || requestType;
        if (!activeType) {
            setDocumentOptions([]);
            return;
        }
        const filteredDocs = filterDocumentsByRequestType(data, activeType);
        setDocumentOptions(filteredDocs);
    };
    useGetPdfDocumentsQuery({ orgId:adminOrgs?.[0]?.id, onSuccess: onSuccessOfDocumentsList });

    const onSuccessForEncounterHistory = (data) => {
        setEncounteredData(data?.map((item) => ({ ...item, name: item?.id + (item?.period?.start ? `(${moment(item?.period?.start).format("MM-DD-YYYY")} | ${moment(item?.period?.start).format("hh:mm A")})` : ''), value: item?.id })));
    };

    usePatientEncounterHistoryQuery({ onSuccess: onSuccessForEncounterHistory, startDate: moment().subtract(3, 'months').format("YYYY-MM-DD"), endDate: moment().format("YYYY-MM-DD"), patientId: paramsObj?.patientId, practitionerId: user?.["custom:unique_id"], refetchOnWindowFocus: false });
    
    const getCategoryVar = (reqType) => {
        return reqType == 'Lab' ? 'Lab Requisition' : ( reqType == 'Diagnostic' ? 'Diagnostic Requisition' : 'Referral');
    };
    
    const categoryVar = getCategoryVar(currentRequestType || requestType);

    const formik = useFormik({
        initialValues: {
            ...FormikObj.initialValues,
            encounterId: paramsObj.encounterId || "",
            requestType: requestType
        },
        validateOnChange: false,
        validateOnBlur: false,
        validate: (values) => {
            const errors = {};
            if (!values.encounterId?.trim()) {
                errors.encounterId = 'Required field';
            }
            if (!values.requestType?.trim()) {
                errors.requestType = 'Required field';
            }
            if (isInternalReferralRequestType(values.requestType)) {
                if (!values.referralType?.trim()) {
                    errors.referralType = 'Required field';
                }
                return errors;
            }
            if (!values.practitionerName?.trim()) {
                errors.practitionerName = 'Required field';
            }
            if (!values.patientName?.trim()) {
                errors.patientName = 'Required field';
            }
            if (!values.documentId?.trim()) {
                errors.documentId = 'Required field';
            }
            return errors;
        },
        onSubmit: async (values) => {
            if (isInternalReferralRequestType(values.requestType)) {
                if (!canCreateInternalReferral) {
                    failed("You do not have permission to create internal referrals.")
                    return
                }
                if (availableReferralTypeOptions.length === 0) {
                    failed("Waiting Room or Virtual Care is not enabled for this organization.")
                    return
                }
                if (!values.referralType?.trim()) {
                    failed("Please select a referral type.")
                    return
                }
                if (values.referralType === "SCHEDULE") {
                    setBookingModalShow(true);
                    return;
                }
                setWizardOpen(true);
                return;
            }
            setNextLoading(true);
            try {
                const validation = await validatePdfBeforeNext(
                    instanceRef.current,
                    initialPdfFormValues.current
                );
                if (!validation.ok) {
                    failed(validation.message);
                    return;
                }
                setOpenModal(true);
            } finally {
                setNextLoading(false);
            }
        },
    });

    // Handle requestType change
    const handleRequestTypeChange = (e) => {
        const newRequestType = e.target.value;
        setCurrentRequestType(newRequestType);
        formik.setFieldValue('requestType', newRequestType);
        formik.setFieldValue('documentId', '');
        formik.setFieldValue('referralType', '');
        
        // Re-filter documents based on new request type
        if (allDocuments.length > 0) {
            const filteredDocs = filterDocumentsByRequestType(allDocuments, newRequestType);
            setDocumentOptions(filteredDocs);
        }
    };

    useEffect(() => {
        let fullPatientName = "";
        let fullPractitionerName = "";
        const tempFormValues = {};

        (async () => {
            try {
                const patientRes = await getPatientData(paramsObj.patientId);
                const patient = patientRes.result;
                setPatientData(patient);

                fullPatientName = capitalizeWords(patient.name?.[0]?.text);
                
                const patientDOB = patient.birthDate.replace(/-/g, "/");
                tempFormValues["patient-dob"] = moment(patient.birthDate).format("MMM-DD-YYYY").toUpperCase();
                tempFormValues["patient-name"] = fullPatientName;
                tempFormValues["patient-street"] = patient.address[0].line[0];
                tempFormValues["patient-city"] = patient.address[0].city;
                tempFormValues["patient-state"] = patient.address[0].state;
                tempFormValues["patient-postalcode"] = patient.address[0].postalCode;
                tempFormValues["patient-sex"] = capitalizeWords(patient.gender);
                tempFormValues["patient-HCN"] = patient.identifier.find(i => i.type === "HCN")?.value || "";
                tempFormValues["patient-telephone"] = patient.telecom.find(t => t.system === "phone")?.value;
                tempFormValues["encounter-id"] = paramsObj.encounterId || "";
                tempFormValues["date"] = moment().format("MMM-DD-YYYY");
                tempFormValues["patient-name-given"] = capitalizeWords(patient.name[0].given[0]);
                tempFormValues["patient-name-family"] = capitalizeWords(patient.name[0].family);
                tempFormValues["patient-age"] = safeAgeString(patientDOB);
                tempFormValues["patient-email"] = patient.telecom.find(t => t.system === "email")?.value;

                const pracRes = await getSingleUser({id: practitionerId, type: "Practitioner", userOrgId: adminOrgs[0].id });
                const prac = pracRes.data;

                fullPractitionerName = capitalizeWords(prac.name?.[0]?.text);

                initialPdfFormValues.current = {
                    ...tempFormValues,
                    "practitioner-name": fullPractitionerName,
                    "practitioner-license": prac.qualification[0].identifier[0].value || "",
                    "practitioner-telephone": splitContactNumber(prac.telecom.find(t => t.system === "phone")?.value || "").phone_number,
                    "practitioner-street": prac.address[0].line[0],
                    "practitioner-city": prac.address[0].city,
                    "practitioner-state": prac.address[0].state,
                    "practitioner-postalcode": prac.address[0].postalCode,
                    "practitioner-signature_af_image": getPractitionerSignatureSource(prac.signatureURL),
                    "practitioner-name-given": capitalizeWords(prac.name[0].given[0]),
                    "practitioner-name-family": capitalizeWords(prac.name[0].family),
                    "practitioner-fax": prac.telecom.find(t => t.system === "phone" && t.use === "work")?.value,
                    "practitioner-email": prac.telecom.find(t => t.system === "email")?.value
                };
                setPdfFormValuesReady(true);

                formik.setValues(
                    {
                        encounterId: paramsObj.encounterId || "",
                        documentId: formik.values.documentId,
                        requestType,
                        referralType: "",
                        patientName: fullPatientName,
                        practitionerName: fullPractitionerName,
                    },
                    false
                );
            } catch (err) {
                failed(err.response?.data?.message || err.response?.data?.error || err.message);
            }
        })();
    }, []);

    const handleFormChange = (e) => {
        if (e?.target?.id === "encounterId") {
            initialPdfFormValues.current = {
                ...initialPdfFormValues.current,
                "encounter-id": e?.target?.value,
            }
            instanceRef?.current?.setFormFieldValues({
                "encounter-id": e?.target?.value,
            });
        }
    };

    useEffect(() => {
        localStorage.setItem("activeTableKey", "seventh");
    }, [])
    
    const encounterRow = encounteredData?.find(
        (row) => row.value === formik.values?.encounterId || row.id === formik.values?.encounterId
    );
    const selectedEncounterOrgId =
        encounterRow?.serviceProvider?.reference?.split("/")?.[1]
        || encounterRow?.managingOrganization?.reference?.split("/")?.[1]
        || null;

    useEffect(() => {
        if (selectedEncounterOrgId) {
            setEncounterOrgId(selectedEncounterOrgId)
            return
        }
        if (!paramsObj?.encounterId) return

        getEncounterRecord({ encounterId: paramsObj.encounterId })
            .then((res) => {
                const data = res?.data
                const orgId =
                    data?.serviceProvider?.reference?.split("/")?.[1] ||
                    data?.managingOrganization?.reference?.split("/")?.[1] ||
                    data?.orgId ||
                    null
                setEncounterOrgId(orgId)
            })
            .catch(() => setEncounterOrgId(adminOrgs?.[0]?.id || null))
    }, [paramsObj?.encounterId, selectedEncounterOrgId, adminOrgs])

    useEffect(() => {
        const orgId = encounterOrgId || adminOrgs?.[0]?.id
        if (!orgId) return

        setOrgLicenseLoading(true)
        getOrganization(orgId)
            .then((orgRes) => {
                setWrEnabled(!!orgRes?.data?.isWaitingRoom)
            })
            .catch((err) => {
                failed(
                    err?.response?.data?.message ||
                        err?.response?.data?.error ||
                        err.message ||
                        "Error loading organization settings"
                )
            })
            .finally(() => setOrgLicenseLoading(false))
        getDiscover(orgId)
            .then((res) => setVvEnabled(!!res?.data?.licensedProduct?.virtualCare))
            .catch(() => setVvEnabled(false))
    }, [encounterOrgId, adminOrgs])

    useEffect(() => {
        if (!isInternalReferral) return

        if (
            formik.values.referralType &&
            !availableReferralTypeOptions.some((opt) => opt.value === formik.values.referralType)
        ) {
            formik.setFieldValue("referralType", "")
        }

        if (availableReferralTypeOptions.length === 1 && !formik.values.referralType) {
            formik.setFieldValue("referralType", availableReferralTypeOptions[0].value)
        }
    }, [isInternalReferral, availableReferralTypeOptions, formik.values.referralType])

    useEffect(() => {
        if (orgLicenseLoading) return
        const showInternalReferralOption =
            isFromInteractionUI &&
            canCreateInternalReferral &&
            (wrEnabled || vvEnabled)
        if (formik.values.requestType === "InternalReferral" && !showInternalReferralOption) {
            formik.setFieldValue("requestType", "Lab")
            formik.setFieldValue("referralType", "")
            setCurrentRequestType("Lab")
        }
    }, [
        orgLicenseLoading,
        wrEnabled,
        vvEnabled,
        canCreateInternalReferral,
        isFromInteractionUI,
        formik.values.requestType,
    ])


    return (
        <>
            {bookingModalShow ? (
                <BookingModal
                    modalShow={bookingModalShow}
                    type="intake"
                    isInternalReferral
                    onHide={() => setBookingModalShow(false)}
                    patientId={paramsObj?.patientId}
                    patientName={patientData?.name?.[0]?.text}
                    encounterId={formik.values?.encounterId}
                    orgId={encounterOrgId || adminOrgs?.[0]?.id}
                    orgName={adminOrgs?.[0]?.name}
                    onSubmitOverride={async (booking) => {
                        const created = await confirmAppointment({
                            organizationRef: booking.organizationRef,
                            holdId: booking.holdId,
                            patientRefs: booking.patientRefs,
                            bookingContext: booking.bookingContext,
                            appointmentStatus: "booked",
                        });
                        await createInternalReferral(
                            buildInternalReferralPayload({
                                sourceEncounterId: booking.sourceEncounterId,
                                patient: { reference: `Patient/${paramsObj?.patientId}` },
                                organization: { reference: `Organization/${booking.organizationRef}` },
                                proceedWith: "SCHEDULE",
                                referralType: mapToReferralType("SCHEDULE"),
                                reasonForReferral: booking.reason,
                                appointment: {
                                    appointmentId: created?.appointmentId,
                                    startsAt: booking.startsAt,
                                    endsAt: booking.endsAt,
                                },
                            })
                        );
                        if (paramsObj?.fromPatient !== "true") {
                            window.close();
                        }
                    }}
                />
            ) : null}
            {wizardOpen ? (
                <InternalReferralWizard
                    modalShow={wizardOpen}
                    onClose={() => setWizardOpen(false)}
                    onSuccess={() => {
                        setWizardOpen(false);
                        if (paramsObj?.fromPatient !== "true") {
                            window.close();
                        }
                    }}
                    sourceEncounterId={formik.values?.encounterId}
                    patientId={paramsObj?.patientId}
                    referralType={formik.values?.referralType}
                />
            ) : null}
            {openModal ? <ServiceLocationModal
                onHide={() => setOpenModal(false)}
                modalShow={openModal}
                paramsObj={paramsObj}
                practitionerData={user}
                instanceRef={instanceRef}
                requestType={currentRequestType || requestType}
                categoryVar={categoryVar}
                patientData={patientData}
                orgName={adminOrgs?.[0]?.name}
                fromServiceRequest={true}
                encounterId={formik.values?.encounterId}
                documentName={documentOptions?.find(item=> item?.id === formik.values?.documentId)?.name}
                encounterOrgId={selectedEncounterOrgId}
            /> : null}
            <section className="common-listing">
                <div className="heading-wrap mb-3">
                    {paramsObj?.fromPatient === "true" && <span style={{ cursor: "pointer" }} onClick={() => navigate(-1)}><ArrowBack /></span>}
                </div>
                <div className="custom-card p-4">
                    <form className="common-form border-fields" onSubmit={formik.handleSubmit} onChange={handleFormChange}>
                        <Row>
                            <Col>
                                {!paramsObj?.encounterId
                                    ? <SelectFiled
                                        formik={formik}
                                        options={encounteredData}
                                        fieldtype={"TextInput"}
                                        keyField={"encounterId"}
                                        label={"Encounter ID"}
                                        placeholder={"111D1"}
                                    />
                                    : <TextInput
                                        disabled
                                        formik={formik}
                                        fieldtype={"TextInput"}
                                        keyField={"encounterId"}
                                        label={"Encounter ID"}
                                        placeholder={"111D1"}
                                    />}
                            </Col>
                            <Col>
                                <SelectFiled
                                    keyField={"requestType"}
                                    label={"Request Type"}
                                    formik={formik}
                                    options={requestTypeOptions}
                                    onChange={handleRequestTypeChange}
                                />
                            </Col>
                        </Row>
                        {isInternalReferral ? (
                            <Row>
                                <Col>
                                    {orgLicenseLoading ? (
                                        <p className="text-muted mb-0">Loading referral options…</p>
                                    ) : availableReferralTypeOptions.length > 0 ? (
                                        <SelectFiled
                                            keyField={"referralType"}
                                            label={"Referral Type"}
                                            formik={formik}
                                            options={availableReferralTypeOptions.map((item) => ({
                                                ...item,
                                                name: item.name,
                                                value: item.value,
                                            }))}
                                            readOnly={!formik.values?.encounterId}
                                        />
                                    ) : (
                                        <p className="error-text mb-0">
                                            This organization does not have Waiting Room or Virtual Care enabled.
                                        </p>
                                    )}
                                </Col>
                            </Row>
                        ) : formik.values.requestType ? (
                        <Row>
                            <Col>
                                <SelectFiled
                                    keyField={"documentId"}
                                    label={"Select Document"}
                                    formik={formik}
                                    options={documentOptions
                                        .map(item => ({ ...item, name: item.documentName, value: item.id }))
                                        .sort((a, b) =>
                                        a.name.localeCompare(b.name, undefined, { sensitivity: 'base' })
                                    )}
                                    readOnly={!formik.values?.encounterId}
                                />
                            </Col>
                        </Row>
                        ) : null}
                        {formik.values.requestType && !isInternalReferral ? (
                        <div className="Pdf-viewer">
                            {formik.values.documentId && pdfFormValuesReady ? (
                                <PdfViewerComponent
                                    key={formik.values.documentId}
                                    initialPdfFormValues={initialPdfFormValues.current}
                                    documentId={documentOptions.find(item => item?.id === formik.values.documentId).id}
                                    instanceRef={instanceRef}
                                />
                            ) : formik.values.documentId ? (
                                <p className="text-muted mb-0">Loading form data…</p>
                            ) : null}
                        </div>
                        ) : null}
                        <div className="btn-wrap" style={{ display: "flex" }}>
                            <Button onClick={() => paramsObj?.fromPatient === "true" ? navigate(-1) : window.close()} variant="secondary" title="Cancel"> Cancel </Button> 
                            <Button
                                type="submit"
                                isLoading={nextLoading}
                                disabled={
                                    !formik.values.requestType?.trim() ||
                                    (isInternalReferral
                                        ? nextLoading ||
                                          orgLicenseLoading ||
                                          availableReferralTypeOptions.length === 0
                                        : !pdfFormValuesReady || nextLoading)
                                }
                            >
                                Next
                            </Button>
                        </div>
                    </form>
                </div>
            </section>
        </>
    )
}

export default ServiceRequest
